module.exports = __webpack_public_path__ + "img/waistband length.42299dc5.png";